import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";
import { gvProductSchema } from "zodios/common/gvProductSchema";

export const storePageProductsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getStorePageProducts",
    method: "get",
    path: "/store_page_products/",
    parameters: [
      {
        name: "store_page_url",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "market_place",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: z.object({
      store_page_url: z.string(),
      products: z.array(gvProductSchema),
    }),
  }).build(),
);
